module.exports = __webpack_public_path__ + "static/media/inventario.cde7506d.png";